import React from 'react';
//import CheckBox from 'grommet/components/CheckBox';
import Box from 'grommet/components/Box';
//import Select from 'grommet/components/Select';
//import Button from 'grommet/components/Button';
//import LineChartIcon from 'grommet/components/icons/base/LineChart';
//import Section from 'grommet/components/Section';
import Tiles from 'grommet/components/Tiles';
import Tile from 'grommet/components/Tile';
import Anchor from 'grommet/components/Anchor';
import ManualInput from "./manualinput.js";
import FileInput from "./fileinput.js";
import FileJsonInput from "./fileinputJson"
import URL from "./url.js";
import EditIcon from 'grommet/components/icons/base/Edit';
import DocumentCsvIcon from 'grommet/components/icons/base/DocumentCsv';
import CloudDownloadIcon from 'grommet/components/icons/base/CloudDownload';


class LRmse extends React.Component {
    constructor() {
        super();
        this.state = { 
            methodology: 0
             }
        this._onSelect = this._onSelect.bind(this);
    }
    _onSelect(event) {
        this.setState({methodology: event})
    }
    
    render() {
        //let { topvalue, bottomvalue,rotate,stack,barcolor,columnwidth,title, legends, exprt } = this.state
        const {methodology} = this.state
        let showFile =  (this.props.currentElement === "Bar" || this.props.currentElement === "Donut" || this.props.currentElement === "Anomaly Analysis GPU")  ? false : true;
        let content;
        switch(methodology) {
            case 0:
                content = <URL currentElement={this.props.currentElement} onSubmit={this.props.onSubmit}/>
                break;
            case 1:
                content = showFile ? <FileInput currentElement={this.props.currentElement} onSubmit={this.props.onSubmit}/> : <div>Not Applicable</div>
                break;
            case 2:
                content = showFile ? <FileJsonInput currentElement={this.props.currentElement} onSubmit={this.props.onSubmit}/> : <div>Not Applicable</div>
                break;
            /* case 2:
                content = <ManualInput dataObject={this.props.dataObject} currentElement={this.props.currentElement} onSubmit={this.props.onSubmit} rows={this.props.rows}/> 
                break;
            default:
                content = <div></div> */
        }
        return (
            <div>
                <h2><strong>Source of Data</strong></h2>
                <Box>	  
                        <Tiles fill={true} flush={true} justify="center" responsive={true} selectable={true} size={"small"} onSelect={this._onSelect} selected={0}>
                           {/*  <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={0} style={{maxWidth: "400px"}} selected={true}>
                                <Box pad="small" colorIndex="light">
                                    <h4>Predefined/Demos</h4>
                                    <Box align="center">
                                        <Anchor>
                                            <EditIcon size="small" colorIndex="grey-1"/>
                                        </Anchor>
                                    </Box>
                                </Box>	
                            </Tile> */}
                            <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={2} style={{maxWidth: "400px"}}>
                                <Box pad="small" colorIndex="light">
                                    <h4>Cloud</h4>
                                    <Box align="center">
                                        <Anchor>
                                            <CloudDownloadIcon size="small" colorIndex="grey-1"/>
                                        </Anchor>
                                    </Box>
                                </Box>	
                            </Tile>
                            <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={1} style={{maxWidth: "400px"}}>
                                <Box pad="small" colorIndex="light">
                                    <h4>File (csv)</h4>
                                    <Box align="center">
                                        <Anchor>
                                            <DocumentCsvIcon size="small" colorIndex="grey-1"/>
                                        </Anchor>
                                    </Box>
                                </Box>	
                            </Tile> 
                            <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={0} style={{maxWidth: "400px"}}>
                                <Box pad="small" colorIndex="light">
                                    <h4>File (json)</h4>
                                    <Box align="center">
                                        <Anchor>
                                            <DocumentCsvIcon size="small" colorIndex="grey-1"/>
                                        </Anchor>
                                    </Box>
                                </Box>	
                            </Tile>
                        </Tiles>

                </Box> 
                <hr style={{width: "100%"}} />
                
                {content}
                
            </div>  
        );
    }
}

export default LRmse;




// WEBPACK FOOTER //
// ./src/samples/data/selectdatasource.js